export const timeout = 30000;

export const API_BASE_URL = "";
export const API_WS_URL = "";
